import React from "react"
import s from "./Desktop.module.scss"
// import QRCode from 'assets/images/dogmented/qr-code.jpg'
import QRCode from "./QRCode"

import Logo from "assets/images/dogmented/logo.svg"

export default function DesktopPage(props) {
  return (
    <div className={s.desktop}>
      <div className={s.contents}>
        <img className={s.logo} src={Logo} alt="Kia Logo" />
        <p className={s.bigText}>Hey, glad you found us.</p>
        <p className={s.littleText}>
          Please scan the QR code to continue to the
          <br />
          Robo Dogmented Reality experience.
        </p>
        <div className={s.rowOfImages}>
          <div className={s.qrCode}>
            {/* <img className={s.qr} src={QRCode} alt="https://kiadogmentedreality.com" /> */}
            <QRCode />
          </div>
        </div>
      </div>
    </div>
  )
}
